import { isRouteErrorResponse, useRouteError } from "react-router";
import { Mascot } from "../ui/Mascot";

/**
 * What is shown when a screen cannot load at all — the server is down, say.
 *
 * The old panel went blank, or worse, stayed on stale data without a word; here it says so
 * and offers the one thing that can be done about it.
 */
export function RouteError() {
  const error = useRouteError();
  const detail = isRouteErrorResponse(error)
    ? String(error.data ?? error.statusText)
    : error instanceof Error
      ? error.message
      : "";

  return (
    <div className="cs-gate">
      <div className="cs-gate-card">
        <Mascot mood="worried" size={110} float />
        <h1 className="cs-gate-title">No se pudo cargar el panel</h1>
        <p className="cs-gate-text">
          El servidor no respondió como esperaba. Puede ser un corte momentáneo: vuelve a intentarlo en unos segundos.
        </p>
        {detail ? <p className="cs-gate-error">{detail}</p> : null}
        <button
          type="button"
          className="ui-button ui-button-primary ui-button-lg ui-button-full"
          onClick={() => window.location.reload()}
        >
          <span>Reintentar</span>
        </button>
      </div>
    </div>
  );
}
